import React from 'react';
import { Section } from './Section';
import { CheckCircle2 } from 'lucide-react';
export function ProductOverview() {
  const features = ['+600 páginas de contenido estructurado', '80+ ejercicios completos listos para entrenar', 'Planificación · Técnica · Evaluación · Gestión · Preparación Física · Marketing', 'Planificación · Corrección · Seguridad · Fidelización · Comunicación', 'Funciona desde hoy mismo en tu cancha'];
  const badges = [{
    text: 'Iniciación',
    color: 'bg-green-500/20 text-green-400 border-green-500/30',
    icon: '🟢'
  }, {
    text: 'Intermedio',
    color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    icon: '🟡'
  }, {
    text: 'Avanzado',
    color: 'bg-red-500/20 text-red-400 border-red-500/30',
    icon: '🔴'
  }, {
    text: 'Gestión',
    color: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    icon: '💼'
  }, {
    text: 'Marketing',
    color: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
    icon: '📱'
  }, {
    text: 'Digital',
    color: 'bg-teal-500/20 text-teal-400 border-teal-500/30',
    icon: '💻'
  }];
  return <Section darker className="border-t border-gold-500/10" data-id="element-305">
      <div className="text-center max-w-4xl mx-auto mb-8 md:mb-16" data-id="element-306">
        <span className="text-gold-400 font-semibold tracking-wider uppercase text-xs md:text-sm mb-2 md:mb-4 block" data-id="element-307">
          Sistema N°1 para Profes de Volley en Argentina
        </span>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-3 md:mb-6" data-id="element-308">
          PROFE DE VOLLEY RESUELTO™
          <br data-id="element-309" />
          <span className="text-gold-500" data-id="element-310">MEGAPACK — SISTEMA COMPLETO</span>
        </h2>
        <p className="text-lg md:text-xl text-gray-300" data-id="element-311">
          6 Tomos + 6 Bonos — Todas las categorías — Todo resuelto.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-312">
        <div className="space-y-4 md:space-y-6" data-id="element-313">
          {features.map((feature, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-314">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-gold-500 flex-shrink-0 mt-0.5 md:mt-1" data-id="element-315" />
              <p className="text-base md:text-lg text-gray-200" data-id="element-316">{feature}</p>
            </div>)}
        </div>

        <div className="bg-navy-800 p-5 md:p-8 rounded-xl md:rounded-2xl border border-navy-700" data-id="element-317">
          <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-4 md:mb-6 border-b border-navy-700 pb-3 md:pb-4" data-id="element-318">
            Niveles y enfoques incluidos:
          </h3>
          <div className="flex flex-wrap gap-2" data-id="element-319">
            {badges.map((badge, idx) => <div key={idx} className={`flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full border ${badge.color} font-medium text-xs md:text-base`} data-id="element-320">
                <span data-id="element-321">{badge.icon}</span>
                {badge.text}
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}